"use strict";
/**
 *
 * Autocomplete
 *
 */
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const downshift_1 = __importDefault(require("downshift"));
const react_window_1 = require("react-window");
// ui
const TextField_1 = require("../TextField");
const Popper_1 = require("../Popper");
const Menu_1 = require("../Menu");
const Paper_1 = require("../Paper");
const ITEM_SIZE = 46;
const MENU_STYLES = {
    marginTop: 5,
    padding: 0,
};
function Autocomplete(props) {
    const { items, getItemId = (item) => (typeof item === 'string' ? item : JSON.stringify(item)), onInputValueChange, listWidth, listHeight, 
    // TextField
    label, dense, required, disabled, readOnly, autoFocus, TextFieldProps = {}, 
    // Popper
    keepPopperMounted, PopperProps = {}, 
    // Paper
    PaperProps, 
    // MenuList
    MenuListProps } = props, rest = __rest(props, ["items", "getItemId", "onInputValueChange", "listWidth", "listHeight", "label", "dense", "required", "disabled", "readOnly", "autoFocus", "TextFieldProps", "keepPopperMounted", "PopperProps", "PaperProps", "MenuListProps"]);
    const handleInputValueChange = react_1.useCallback((value) => {
        if (onInputValueChange) {
            onInputValueChange(value || null);
        }
    }, [onInputValueChange]);
    const anchorEl = react_1.useRef(null);
    return (react_1.default.createElement(downshift_1.default, Object.assign({ defaultHighlightedIndex: 0 }, rest, { onInputValueChange: handleInputValueChange }), ({ getInputProps, openMenu, getMenuProps, isOpen: downshiftIsOpen, getItemProps, itemToString, highlightedIndex, selectedItem, }) => {
        const _a = getInputProps({
            ref: anchorEl,
            onFocus: (event) => {
                if (TextFieldProps.onFocus) {
                    TextFieldProps.onFocus(event);
                }
                openMenu();
            },
        }), { ref } = _a, restInputProps = __rest(_a, ["ref"]);
        const isOpen = downshiftIsOpen && items.length > 0;
        return (react_1.default.createElement("div", null,
            react_1.default.createElement(TextField_1.TextField, Object.assign({ label: label, dense: dense }, TextFieldProps, restInputProps, { required: required, disabled: disabled, readOnly: readOnly, autoFocus: autoFocus, ref: ref })),
            !readOnly && (keepPopperMounted || isOpen) && (react_1.default.createElement(Popper_1.Popper, Object.assign({}, PopperProps, { open: isOpen, anchorEl: anchorEl.current }),
                react_1.default.createElement(Paper_1.Paper, Object.assign({ elevation: 2 }, PaperProps),
                    react_1.default.createElement(Menu_1.MenuList, Object.assign({}, (isOpen
                        ? getMenuProps(Object.assign(Object.assign({}, MenuListProps), { style: MENU_STYLES }), { suppressRefError: true })
                        : {})),
                        react_1.default.createElement(react_window_1.FixedSizeList, { width: typeof listWidth === 'number'
                                ? listWidth
                                : anchorEl.current
                                    ? anchorEl.current.clientWidth
                                    : 0, height: typeof listHeight === 'number'
                                ? listHeight
                                : Math.min(ITEM_SIZE * 7, items.length * ITEM_SIZE), itemSize: ITEM_SIZE, itemCount: items.length }, ({ index, style }) => {
                            const item = items[index];
                            return (react_1.default.createElement(Menu_1.MenuItem, Object.assign({}, getItemProps({
                                index,
                                item,
                                selected: selectedItem === getItemId(item),
                                tabIndex: -1,
                                style,
                            }), { highlighted: highlightedIndex === index }), itemToString(item)));
                        })))))));
    }));
}
exports.Autocomplete = Autocomplete;
